import { AxiosResponse } from "axios";
import { IJournalResponse, IJournalPayload } from "~/types/journal";
import { vrachApi } from "~/utils/api";

// Note: Сервис получение "талонов" из журнала
export const fetchJournalService = (payload: IJournalPayload) => {
  return vrachApi.post<
    IJournalResponse,
    AxiosResponse<IJournalResponse, typeof payload>,
    typeof payload
  >(`/account/patient/history`, payload);
};
